export const INDEX = "index";
export const CONCEPT = "concept";
export const QUALITY_INDEX = "qualityIndex";
export const QUALITY_RESULTS = "qualityResults";
export const QUALITY_DELTA = "qualityDelta";

export const NOTES = "notes";
export const DEATH = "death";
export const SOURCE_HISTORY_INDEX = "sourceHistoryIndex";
export const DENSITY_RECORDS_PERSON = "densityRecordsPerson";
export const DENSITY_TOTAL = "densityTotal";
export const DOMAIN_SUMMARY = "domainSummary";
export const HELP = "help";
export const METADATA = "metadata";
export const CDM_SOURCE = "cdmSource";
export const NETWORK_QUALITY_SUMMARY = "networkQualitySummary";
export const RECORDS_DOMAIN = "recordsDomain";
export const OBSERVATION_PERIOD = "observationPeriod";
export const ACHILLES_PERFORMANCE = "achillesPerformance";
export const COHORT_DIAGNOSTICS_PERFORMANCE = "cohort_diagnostics_performance";
export const PERSON = "person";
export const SOURCE_CONCEPT = "sourceConcept";
export const QUALITY_COMPLETENESS = "qualityCompleteness";
export const NETWORK_UNMAPPED_SOURCE_CODES = "networkUnmappedSourceCodes";
export const DOMAIN_ISSUES = "domainIssues";
export const DOMAIN_VISIT_STRATIFICATION = "domainVisitStratification";
export const DOMAIN_DRUG_STRATIFICATION = "domainDrugStratification";
export const DENSITY_DOMAIN_PERSON = "densityDomainPerson";
export const NETWORK_PERFORMANCE = "networkPerformance";
export const EXPORT_QUERY_INDEX = "exportQueryIndex";
export const TEMPORAL_CHARACTERIZATION = "temporalCharacterization";

export const COHORT_INDEX = "cohortsIndex";
export const COST_INDEX = "costIndex";
export const COST_DRILLDOWN = "costDrilldown";
export const COST_DOMAIN_SUMMARY = "costDomainSummary";
export const COST_CONCEPT = "costConcept";
export const COST_TIMESERIES = "costTimeseries";

export const COHORT_CHARACTERIZATION = "cohortReport";

export const COHORT_INDEX_EVENT_BREAKDOWN = "cohortIndexEventBreakdown";

export const COHORT_TEMPORAL_COVARIATE_DISTRIBUTION =
  "cohortTemporalCovariateDistribution";

export const LOCATION = "location";
